import { useMobileMediaQuery } from "../../hooks/responsiveMediaQueries";

const NonMobile = ({ children }) => {
  return useMobileMediaQuery() ? null : children
}

export default NonMobile;